import { notice } from '@/api/index'

export function getNoticeNotRead () {
  return notice.request({
    method: 'post',
    url: '/GET_NOTICE_NOT_READ'
  })
}
